import React, { useState } from "react";
import { ContactForm } from "components/ContactForm/ContactForm";

export default function UKCFDAR7({
  pdfUrl,
  pdfUrlCN,
  pdfName,
  pdfDescription,
  pdfNameCN,
  pdfPreview,
}: {
  pdfUrl: any;
  pdfName: string[];
  pdfDescription?: string[];
  pdfPreview: any;
  pdfUrlCN?: any;
  pdfNameCN?: string[];
}) {
  const [showForm, setShowForm] = useState(false);
  const [selectedLanguage, setSelectedLanguage] = useState<"en" | "cn">("en");

  const handleShowForm = (language: "en" | "cn") => {
    setSelectedLanguage(language);
    if (localStorage.getItem("download-allowed") === "true") {
      (async () => {
        await handleDownload(language);
      })();
    } else {
      setShowForm(true);
    }
  };

  const handleDownload = async (language: "en" | "cn") => {
    const res = await fetch(language === "cn" ? pdfUrlCN : pdfUrl);
    const blob = await res.blob();
    const url = window.URL.createObjectURL(blob);
    const a = document.createElement("a");
    a.href = url;
    a.download =
      language === "cn" && pdfNameCN
        ? pdfNameCN.join("-") + ".pdf"
        : pdfName
          ? pdfName.join("-") + ".pdf"
          : "report.pdf";
    a.click();
    window.URL.revokeObjectURL(url);
  };

  return (
    <div className="relative -mx-10 bg-main-gray p-10 py-20 sm:py-10 mt-10">
      <div className="absolute top-0 right-8 px-8 py-2 text-main bg-white/70 shadow-lg">
        {/* // <div className="absolute top-4 right-4 border-[1.5px] border-main px-6 text-main bg-white/70"> */}
        White Paper
      </div>

      <div className=" flex flex-col items-start lg:items-center lg:flex-row lg:gap-8">
        <img
          className=""
          style={{
            border: "none",
            width: "auto",
            height: "260px",
            padding: "0",
            marginTop: "0",
          }}
          src={pdfPreview}
          alt="PDF preview"
        />
        <div className="flex flex-col gap-6 items-start justify-between mt-10 sm:mb-10">
          <p className="flex flex-col">
            <span className="mb-4">WeBridge Insights</span>
            <span className="font-bold text-3xl font-serif text-main">
              {pdfName[0]}:
            </span>
            <span className="font-bold text-3xl font-serif">{pdfName[1]}</span>
            {pdfDescription && (
              <span className="text-xl font-serif">{pdfDescription[0]}</span>
            )}
          </p>
          <div className="flex flex-row gap-2 text-base">
            <span
              onClick={() => {
                handleShowForm("en");
              }}
              className="hover:cursor-pointer hover:bg-secondary-dark/90 bg-secondary-dark px-4 py-2 font-medium fw-700"
              style={{ color: "white" }}
            >
              Download Report{pdfUrlCN ? " (EN) " : ""}
            </span>
            {pdfUrlCN && (
              <span
                onClick={() => {
                  handleShowForm("cn");
                }}
                className="hover:cursor-pointer hover:bg-secondary-dark/90 bg-secondary-dark px-4 py-2 font-medium fw-700"
                style={{ color: "white" }}
              >
                下载报告(中文)
              </span>
            )}
          </div>
        </div>
      </div>
      {showForm && (
        <div className="sm:m-6">
          <ContactForm
            pdfUrl={pdfUrl}
            pdfUrlCN={pdfUrlCN}
            pdfName={pdfName}
            pdfNameCN={pdfNameCN}
            language={selectedLanguage}
          />
        </div>
      )}
    </div>
  );
}
